const FROM_GALLERY_PAGE_REQUEST = 'FROM_GALLERY_PAGE_REQUEST';

export default FROM_GALLERY_PAGE_REQUEST;
